
import config from '../config/enviroment'

const loadCheckout = (callback) => {
  const existingScript = document.getElementById('checkoutScript');
  if (!existingScript) {
    const script = document.createElement('script');
    script.src = config.epaycoCheckout;
    script.id = 'checkoutScript';
    document.body.appendChild(script);
    script.onload = () => { 
      if (callback) callback();
    };
  }
  if (existingScript && callback) callback();
};
export default loadCheckout;